import React from 'react'
import clsx from 'clsx'

import Tooltip from '../Tooltip'

import useStyles from './styles'

const ModalTextField = ({
  className,
  children,
  title,
  toolTipText = '',
  ...props
}) => {
  const classes = useStyles()

  const child = React.useMemo(
    () => React.Children.toArray(children)[0],
    [children]
  )
  const newChild = React.useMemo(
    () =>
      React.cloneElement(child, {
        className: clsx('text', child.props.className)
      }),
    [child]
  )

  return (
    <div className={clsx(classes.root, className)} {...props}>
      <Tooltip arrow title={toolTipText}>
        <div className='adorn'>{title}</div>
      </Tooltip>

      <div className={classes.input}>{newChild}</div>
    </div>
  )
}

export default ModalTextField
